import MobileDetect from 'mobile-detect'
import { useMemo } from 'react'

interface DetectedDevice {
  hasTouch: boolean
  isDesktop: boolean
  isMobile: boolean
  isPhone: boolean
  isTablet: boolean
  OS: string
}

const useDeviceDetect = () =>
  useMemo<DetectedDevice>(() => {
    const { userAgent } = navigator
    const mobileDetect = new MobileDetect(userAgent)
    const isMobile = !!mobileDetect.mobile() || /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent)
    const isTablet = !!mobileDetect.tablet() || /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent)
    const isPhone = !!mobileDetect.phone() || (isMobile && !isTablet)
    const isDesktop = !isPhone && !isTablet && !isMobile

    return {
      hasTouch:
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        // @ts-expect-error msMaxTouchPoints is a non-standard property
        navigator.msMaxTouchPoints > 0 ||
        window.matchMedia?.('(pointer:coarse)')?.media === '(pointer:coarse)' ||
        !!mobileDetect.mobile(),
      isDesktop,
      isMobile,
      isPhone,
      isTablet,
      OS: mobileDetect.os(),
    }
  }, []) // Empty dependency array since navigator.userAgent doesn't change during app lifetime

export default useDeviceDetect
